import styled from 'styled-components';
export const StyledImg = styled.img `
  box-sizing: border-box;
  height: 100%;
  width: 100%;
  padding: ${({ isFallbackSrc }) => (isFallbackSrc ? '1.5rem' : '0')};
  object-fit: ${({ isFallbackSrc }) => (isFallbackSrc ? 'contain' : 'cover')};
  background-color: ${({ isFallbackSrc, fallbackBackgroundColor }) => isFallbackSrc ? fallbackBackgroundColor : ''};
`;
